import React from "react";
import Link from "gatsby-link";


export default class Pagination extends React.Component {

  render() {
    const {pathContext: {index, first, last, pageCount, pathPrefix}} = this.props;
    const previousUrl = index - 1 === 1 ? `/${pathPrefix}` : (index - 1).toString();
    const nextUrl = `/${pathPrefix}/${index + 1}`;

    const previousButton = !first ? (
      <Link to={previousUrl} className="pagination-previous">
        Previous
      </Link>
    ) : (
      /* eslint jsx-a11y/anchor-is-valid: "off" */
      <a className="pagination-previous" disabled>
        Previous
      </a>
    );
    const nextButton = !last ? (
      <Link to={nextUrl} className="pagination-next">
        Next
      </Link>
    ) : (
      /* eslint jsx-a11y/anchor-is-valid: "off" */
      <a className="pagination-next" disabled>
        Next
      </a>
    );

    return (
      <nav className="pagination is-centered" aria-label="pagination" style={{marginBottom: "20px"}}>
        {previousButton}
        {nextButton}
        <ul className="pagination-list">
          {
            index > 2 ?
              (
                <li>
                  <Link to={`/${pathPrefix}/`} className="pagination-link" aria-label="Goto page 1">
                    1
                  </Link>
                </li>
              ) : null
          }

          {
            index > 3 ?
              (
                <li>
                  <span className="pagination-ellipsis">
                    &hellip;
                  </span>
                </li>
              ) : null
          }

          {
            index > 1 ?
              (
                <li>
                  <Link
                    to={index - 1 > 1 ? `/${pathPrefix}/${index - 1}` : `/${pathPrefix}/`}
                    className="pagination-link"
                    aria-label={`Goto page ${index - 1}`}
                  >
                    {index - 1}
                  </Link>
                </li>
              ) : null
          }

          <li>
            <Link
              to={index > 1 ? `/${pathPrefix}/${index}` : `/${pathPrefix}`}
              className="pagination-link is-current"
              aria-label={`Page ${index}`}
              aria-current="page"
            >
              {index}
            </Link>
          </li>
          
          {
            pageCount - index > 0 ?
              (
                <li>
                  <Link to={`/${pathPrefix}/${index + 1}`} className="pagination-link" aria-label={`Goto page ${index + 1}`}>
                    {index + 1}
                  </Link>
                </li>
              ) : null
          }

          {
            pageCount - index > 2 ?
              (
                <li>
                  <span className="pagination-ellipsis">
                    &hellip;
                  </span>
                </li>
              ) : null
          }

          {
            pageCount - index > 1 ?
              (
                <li>
                  <Link to={`/${pathPrefix}/${pageCount}`} className="pagination-link" aria-label={`Goto page ${pageCount}`}>
                    {pageCount}
                  </Link>
                </li>
              ) : null
          }
        </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pagination/index.jsx